import React from "react";
import Breadcrumb from "../../common/Breadcrumb";
import ContactWrapperArea from "./ContactWrapperArea";

function Contact() {
  return (
    <>
      <Breadcrumb name="Contact" />
      <ContactWrapperArea />
    </>
  );
}

export default Contact;
